export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/character_animation.8b27364.svg";